import { SectionSubtitle } from "@/components/SectionSubtitle";
import { SectionTitle } from "@/components/SectionTitle";
import { useMuiTheme } from "@/hooks/useMuiTheme";
import { Box, Container, Typography } from "@mui/material";
import { type NextPage } from "next";
import { useTranslation } from "react-i18next";

export const AboutHeadingSection: NextPage = () => {
  const theme = useMuiTheme();

  const { t, i18n } = useTranslation();

  return (
    <Box sx={{}}>
      <Box sx={{ py: { xs: 3, md: 4, lg: 5 } }}>
        <Container sx={{}}>
          {i18n.language === "th" && <SectionSubtitle>About us</SectionSubtitle>}
          <SectionTitle sx={{ mt: 1 }}>{t("about-heading.title")}</SectionTitle>
        </Container>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "tertiary.100",
          minHeight: 368,
          py: {
            xs: 3,
            md: 5,
            lg: 8,
          },
          borderRadius: "0 240px 0 0",
          [theme.breakpoints.down("lg")]: {
            borderRadius: 0,
          },
        }}
      >
        <Container
          sx={{
            position: "relative",
            flex: 1,
            // height: "100%",
            display: "grid",
            gridTemplateColumns: "1.1fr 0.9fr",
            columnGap: 6,
            [theme.breakpoints.down("lg")]: {
              gridTemplateColumns: "1fr",
              gridTemplateRows: "repeat(2, auto)",
              rowGap: 2,
            },
          }}
        >
          <Box
            sx={{
              position: "relative",
              height: "fit-content",
              my: 4,
              ":before, :after": {
                position: "absolute",
                display: "block",
                fontSize: "4rem",
                fontWeight: "bold",
                height: 16,
                color: "primary.300",
              },
              ":before": {
                content: "open-quote",
                left: 0,
                top: 0,
                transform: "translateY(-100%)",
              },
              ":after": {
                content: "close-quote",
                right: 0,
                bottom: 0,
                transform: "translateY(300%)",
              },
            }}
          >
            <Typography variant="h3" color="text.darkblue">
              DNAcanvas
            </Typography>
            <Typography color="translucent.black.56" sx={{ mt: 2 }}>
              “{t("about-heading.vision")}”
            </Typography>
          </Box>
          <Box
            component="img"
            src="/assets/imgs/webp/about-heading.webp"
            alt="About page heading image"
            sx={{
              gridColumn: "2",
              width: "100%",
              position: "absolute",
              right: 0,
              bottom: 0,
              [theme.breakpoints.down("lg")]: {
                position: "static",
                gridColumn: "1",
                gridRow: "2",
                maxWidth: 600,
                mx: "auto",
              },
            }}
          />
        </Container>
      </Box>
      {/* <Stack spacing={{ base: 10, md: 16 }}>
          <Box flex="1">
            <Typography
              fontSize={{ base: "4xl", md: "5xl" }}
              fontWeight="bold"
              lineHeight="shorter"
              color="primary.500"
            >
              About
            </Typography>
            <Typography
              mt={4}
              fontSize={{ base: "lg", md: "xl" }}
              color="primary.500"
              fontWeight="medium"
            >
              DNA Canvas is a software company that provides DNA analysis services for the
              agriculture industry. We are a team of bioinformaticians, software engineers, and data
              scientists who believe that DNA analysis is the future of agriculture.
            </Typography>
          </Box>
          <Box flex="1">
            <Box
              component="img"
              src="/images/about/about-image.svg"
              alt="DNA Canvas"
              width={500}
              height={500}
            />
          </Box>
        </Stack> */}
    </Box>
  );
};
